
define('text!templates/widgets/dataGridCells/hyperlinkCell.html',[],function () { return '<a data-bind="text: label, attr: { href: href, title: $data.title }"></a>';});

